import React from 'react';
import Main from "./views/Main";
import { configureStore } from './store/createStore';
import { Provider } from 'react-redux';

const App: React.FC<{}> = () => {
    return (
        <Provider store={configureStore()}>
            <Main />
        </Provider>
    )
}

export default App;
